<script setup lang="ts">
import PhIcon from '@/components/PhIcon.vue'
import ButtonNavbar from '@/components/button/ButtonNavbar.vue'
import LabelBase from '@/components/label/LabelBase.vue'
import { computed } from 'vue'
import { useAppStore } from '@/stores/app.store.ts'
import type { User } from '@/types/model'
import { useAuthStore } from '@/stores/app/auth.store'
import { useRouter } from 'vue-router'

// ambil fungsi loginGoogle dan signOut dari store
const { signOut } = useAuthStore()

// ambil fungsi router
const router = useRouter()

// ambil data user
const appStore = useAppStore()
const user = computed(() => appStore.user as User)
const initial = computed(() => getInitials(user.value ? user.value.name : 'User'))

const getInitials = (name: string) => {
  const names = name.split(' ')
  if (names.length === 1) {
    return name.charAt(0)
  }
  return names[0].charAt(0) + names[1].charAt(0)
}

const logout = () => {
  signOut()

  // refresh halaman
  router.push({ name: 'home' }).then(() => {
    window.location.reload()
  })
}
</script>

<template>
  <div class="flex gap-2 justify-between p-2 py-4">
    <!-- Avatar button -->
    <div
      class="self-center h-9 min-w-9 rounded-full flex items-center justify-center bg-stone-500 text-white text-xs transition-colors duration-150"
    >
      {{ initial }}
    </div>

    <div class="self-center flex flex-col mr-auto">
      <label-base size="sm" class="whitespace-nowrap">{{ user?.name ?? 'Guest' }}</label-base>
      <label-base size="xs" class="text-stone-500">{{ user?.email ?? 'unknown' }}</label-base>
    </div>

    <div class="self-center">
      <button-navbar @click="logout">
        <ph-icon name="sign-out" class="text-red-500"></ph-icon>
      </button-navbar>
    </div>
  </div>
</template>

<style scoped></style>
